export const timeDuration = (prevTime: Date, currentTime: Date): string => {
  const duration = (currentTime.getTime() - prevTime.getTime()) / 1000
  const seconds = duration % 60
  const minutes = Math.floor(duration / 60)
  return minutes > 0 ? minutes.toFixed() + ' M' + seconds + ' S' : seconds.toFixed(2) + ' S'
}
